"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("../plugins/content/components");
const FinishMessageCustom = _ref => {
  let readOnly = _ref.readOnly,
    widget = _ref.widget;
  const _widget$settings = widget.settings,
    finishMessage = _widget$settings.finish_message,
    finishMessageBackground = _widget$settings.finish_message_background;
  const content = valueParse(finishMessage);
  return content.entityMap ? /*#__PURE__*/_react.default.createElement(_components.DraftEditor, {
    readOnly: readOnly,
    value: content,
    editorStyle: {
      backgroundColor: "rgba(".concat(finishMessageBackground, ")"),
      borderRadius: 3
    }
  }) : /*#__PURE__*/_react.default.createElement(_components.SlateEditor, {
    content: finishMessage,
    readOnly: readOnly,
    contentStyles: {
      backgroundColor: '#fff',
      color: '#666',
      padding: 10
    }
  });
};

//
// Helper functions
//
const valueParse = message => {
  try {
    return JSON.parse(message);
  } catch (e) {
    return message;
  }
};

//
// PropTypes
//

FinishMessageCustom.defaultProps = {
  readOnly: true
};
var _default = exports.default = FinishMessageCustom;